const params = new URLSearchParams(window.location.search);
const table = params.get("table")
  ? params.get("table")
  : "demo_kenya_cardano_37mct";

const filenames = [
  // "digi-data-v1/s2/dr/KE/37MCT/S2_DR_T37MCT_20230602_MS_cog.tif",
  "digi-data-v1/s2/dr/KE/37MCT/S2_DR_T37MCT_20230826_MS_cog.tif",
  // "digi-data-v1/s2/dr/KE/37MCT/S2_DR_T37MCT_20230925_MS_cog.tif",
];
const renderParam = params.get("render") ? params.get("render") : "rgbn_rgb";
const region = params.get("region") ? params.get("region") : "Kenya";
const fields = params.get("fields") ? params.get("fields") : 5499;
const hectares = params.get("hectares") ? params.get("hectares") : 6716;
const countryCode = params.get("countryCode")
  ? params.get("countryCode")
  : "ke";
const localMinMax = (params.get("localMinMax") &&
  params.get("localMinMax").split(",")) || [
  -1.990691, -0.084782, 0.392774, 0.713803, 1.036445, 2.69034,
];
// const localMin = localMinMax && localMinMax.split(",")[0];
// const localMax = localMinMax && localMinMax.split(",")[1];
const localMin = localMinMax[0];
const localMax = localMinMax[localMinMax.length - 1];
// const local25 = params.get("local25");
// const local75 = params.get("local75");
// const local50 = params.get("local50");
const defaultFBI = params.get("defaultFBI");
const indexName = params.get("indexName") ? params.get("indexName") : "SustInd";
const indexDesc = params.get("indexDesc");
const inverseColor =
  params.get("inverseColor") && params.get("inverseColor") === "true"
    ? true
    : false;
// Add render params

// http://dev.sustainability-demo.digifarm.io.s3-website.eu-central-1.amazonaws.com/?table=demo_mz_37lcd_37lee_37lbd_37lbc&countryCode=MZ&indexName=SustInd&indexDesc=SustInd&inverseColor=false&fields=3437&hectares=5734&localMinMax=-5.944071,-0.443365,0.721661,1.614718,2.614434,7.051502&region=Mozambique&render=rgbn_rgb#14/-15.55590346204662/36.49433097984252

//  http://dev.sustainability-demo.digifarm.io.s3-website.eu-central-1.amazonaws.com/?table=demo_mz_37lcd_37lee_37lbd_37lbc&countryCode=MZ&indexName=BsiInd&indexDesc=BSIInd&inverseColor=true&fields=3437&hectares=5734&localMinMax=-2.255277,-0.287858,0.272486,0.796002,1.380631,5.097458&region=Mozambique&render=rgbn_rgb#14/-15.55590346204662/36.49433097984252

const configObjMain = {
  demo_makueni_37mcu_37mcv_37mdr_37mct_37mdt: {
    2023: {
      table: "demo_makueni_37mcu_37mcv_37mdr_37mct_37mdt",
      region: "Kenya",
      fields: 17119,
      hectares: 18187,
      countryCode: "ke",
      localMin: -65.775,
      localMax: 142.115,
      localMinMax: {
        SustInd: [-65.775, -0.016299, 0.362144, 0.666479, 1.125137, 142.115],
        BsiInd: [-1.379091, -0.098243, 0.080901, 0.266428, 0.566763, 2.046121],
      },
      defaultFBI,
      indexName: "SustInd",
      indexDesc,
      inverseColor: false,
    },

    2024: {
      table: "demo_makueni_37mcu_37mcv_37mdr_37mct_37mdt_2024",
      region: "Kenya",
      fields: 23935,
      hectares: 15972,
      countryCode: "ke",
      localMin: -5.563733,
      localMax: 6.547461,
      localMinMax: {
        SustInd: [-5.563733, -0.253324, 0.497194, 1.134635, 1.930863, 6.547461],
        BsiInd: [-5.105359, -1.64988, -1.05492, -0.483063, 0.112096, 5.541947],
      },
      defaultFBI,
      indexName: "SustInd",
      indexDesc,
      inverseColor: false,
    },
    years: [2023, 2024],
    layers: [
      "SustInd",
      "BsiInd",
      "Deforestation",
      "fields",
      "crop",
      "timeseries",
    ],

    cropYears: [2018, 2019, 2020, 2021, 2022, 2023, 2024],

    cropTables: {
      summer: {
        2018: "demo_crop_kenya_oct_25_summer_2018",
        2019: "demo_crop_kenya_oct_25_summer_2019",
        2020: "demo_crop_kenya_oct_25_summer_2020",
        2021: "demo_crop_kenya_oct_25_summer_2021",
        2022: "demo_crop_kenya_oct_25_summer_2022",
        2023: "demo_crop_kenya_oct_25_summer_2023",
        2024: "demo_crop_kenya_oct_25_summer_2024",
      },
      winter: {
        2018: "demo_crop_kenya_oct_25_winter_2018",
        2019: "demo_crop_kenya_oct_25_winter_2019",
        2020: "demo_crop_kenya_oct_25_winter_2020",
        2021: "demo_crop_kenya_oct_25_winter_2021",
        2022: "demo_crop_kenya_oct_25_winter_2022",
        2023: "demo_crop_kenya_oct_25_winter_2023",
        2024: "demo_crop_kenya_oct_25_winter_2024",
      },
    },
  },

  demo_mz_37lcd_37lee_37lbd_37lbc: {
    2024: {
      table: "demo_mz_37lcd_37lee_37lbd_37lbc",
      countryCode: "mz",
      index: {
        name: "SustInd",
        description: "SustInd",
        inverseColor: false,
      },
      fields: 3437,
      hectares: 5734,
      localMin: -5.944071,
      localMax: 7.051502,
      localMinMax: {
        SustInd: [-5.944071, -0.443365, 0.721661, 1.614718, 2.614434, 7.051502],
        BsiInd: [-5.944071, -0.443365, 0.721661, 1.614718, 2.614434, 7.051502],
      },
      region: "Mozambique",
    },
    years: [2024],
    layers: ["SustInd", "BsiInd", "Deforestation", "fields", "timeseries"],
  },

  demo_kenya_cardano_37mct: {
    2024: {
      table: "demo_kenya_cardano_37mct_ts_new",
      region: "Kenya",
      fields: 5499,
      hectares: 6716,
      countryCode: "ke",
      localMin: -1.990691,
      localMax: 2.69034,
      localMinMax: {
        SustInd: [-1.990691, -0.084782, 0.392774, 0.713803, 1.036445, 2.69034],
        BsiInd: [-5.105359, -1.64988, -1.05492, -0.483063, 0.112096, 5.541947],
      },
      defaultFBI,
      indexName: "SustInd",
      indexDesc,
      inverseColor: false,
    },
    years: [2024],
    layers: ["SustInd", "fields", "timeseries"],
  },
};
const indexNames = {
  SustInd: "Sustainability Index",
  BsiInd: "Soil Exposure",
  Deforestation: "Deforestation",
  fields: "Field Boundary",
  crop: "Crop Classification",
  timeseries: "Timeseries",
};

const configObj = configObjMain[table];

export {
  table,
  filenames,
  renderParam,
  region,
  fields,
  hectares,
  countryCode,
  localMin,
  localMax,
  localMinMax,
  defaultFBI,
  indexName,
  indexDesc,
  inverseColor,
  configObj,
  indexNames,
};
